import { set } from 'date-fns';
import React, { createContext, useState} from 'react'


export interface Freight {
    id?: number;
    type: string;
    detail: string;
    readyToShip: string;
    deadLine: string;
    status: string;
    observation?: string;
    orderNumber?: string;
    companyId?: number;
    addressId?: number;
    routeId?: number;
    company?: {
      id: number;
      companyName: string;
    };
    address: {
      id?: number;
      street: string;
      number: string;
      complement: string;
      cep: number;
      neighborhood: {
        id: number;
        name: string;
        city: {
          id: number;
          name: string;
          state: {
            id: number;
            name: string;
            uf: string;
          };
        };
      };
    };
    route?: {
      id: number;
      date: string;
      status: string;
      track: string;
      origin: string | null;
      url: string;
      vehicleId: number;
    };
    load: {
      id?: number;
      height: string;
      width: string;
      length: string;
      cubage: string;
      weight: string;
      freightId?: number;
      detail: string;
    };
  }

interface FreightContextProps {
    freight: Freight | null;
    setFreight: React.Dispatch<React.SetStateAction<Freight | null>>
}

export const FreightContext = createContext<FreightContextProps>({
    freight: {
      type: "",
      detail: "",
      deadLine: "",
      readyToShip:"",
      status: "",
      address: {
        id: 0,
        street: "",
        number: "",
        complement: "",
        cep: 0,
        neighborhood: {
          name: "",
          id: 0,
          city: {
            name: "",
            id: 0,
            state: {
              id: 0,
              name: "",
              uf: ""
            }
          }
        }
      },
      load: {
        height: "",
        width: "",
        length: "",
        cubage: "",
        weight: "",
        detail: ""
      }
    },
    setFreight: ()=>{ return}
})


export const FreightProvider: React.FC<any> = ({children})=>{
    const [freight, setFreight] = useState<Freight | null>(null)


    return(
        <FreightContext.Provider value={{freight, setFreight}}>
            {children}
        </FreightContext.Provider>
    )
}



